//
// Copyright (c) 2020 Astute Global, Inc.
//
// A module for the Site Map editor.
//

define([
  "marionette",
  "jquery",
  "underscore",
  "messaging/messenger",
  "./tableOfContentsEntryView",
  "./tableOfContentsLevel/tableOfContentsLevelModule",
  "modules/authoringAdmin/tableOfContents/tableOfContentsHistoryModal/tableOfContentsHistoryModalModule",
], function (
  Marionette,
  $,
  _,
  Messenger,
  TableOfContentsEntryView,
  TableOfContentsLevelsModule,
  TableOfContentsHistoryModalModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "tableOfContentsEntry";
      this.region = options.region;
      this.tableOfContents = null;
    },
    hide: function () {
      if (this.view) {
        this.view.close();
        this.view = null;
      }
      this.tableOfContents = null;
      if (this.levels) {
        this._closeSubModule(this.levels);
        this.levels = null;
      }
    },
    show: function (tableOfContents) {
      this.tableOfContents = tableOfContents;
      this.view = new TableOfContentsEntryView.tableOfContentsEntryView({ model: tableOfContents });
      this.levels = this.addSubModule(
        new TableOfContentsLevelsModule({
          region: this.view.levels,
        }),
      );

      Messenger.onSave(function () {
        if (this.tableOfContents) {
          this.tableOfContents.saveModel();
        } else {
          Messenger.saveAttempted(true);
        }
      }, this);

      this.view.on("remove:tableOfContents", this._onRemoveTableOfContents, this);
      this.view.on("show:history", this._onShowHistory, this);
      this.view.on("show", this._showSubViews, this);
      this.showRegion(this.view);
    },
    _onRemoveTableOfContents: function () {
      const model = this.tableOfContents;
      if (!model) {
        return;
      }
      Messenger.yesNoDialog(
        $.t("admin.tableOfContents.confirmTableOfContentsDelete", { name: model.get("name") }),
        {
          yes: function () {
            Messenger.vent.trigger("track:interaction", {
              action: "Delete Table of Contents",
              id: model.id,
              idType: "Table of Contents",
              object: "Table of Contents",
            });
            Messenger.vent.trigger("delete:tableOfContents", model);
          },
        },
        this,
      );
    },
    _onShowHistory: function () {
      if (!this.tableOfContents) {
        return;
      }
      Messenger.vent.trigger(
        "show:modal",
        TableOfContentsHistoryModalModule,
        {
          editMode: false,
        },
        this.tableOfContents,
        {
          title: $.t("admin.tableOfContents.history"),
          closeButton: true,
          closeOnBackgroundClick: false,
          modalWidth: "900px",
          modalHeight: "600px",
          trackInteraction: {
            action: "Table of Contents History",
            id: this.tableOfContents.id,
            idType: "Table of Contents",
            object: "Table of Contents",
          },
        },
      );
    },
    _showSubViews: function () {
      this.levels.show(this.tableOfContents);
    },
  });
});
